<div class="chipCont__cont">
  <div class="chipCont__cont--{{gridOrSlider}}">
    <ng-content></ng-content>
  </div>
</div>